
                import wasm from "@shortex/perspective-viewer/dist/pkg/perspective_bg.wasm";
                async function get_wasm() {
                    return new URL(wasm, import.meta.url);
                }

                export default get_wasm();
            